import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { postReprocessDepositMigration } from '../../../../actions';

const REPROCESS_CONFIRMATION_MESSAGE =
  'Reprocesar vuelve a correr el cruce completo de esta carga con las cuentas vigentes, como si el archivo se acabara de subir.';

const ReprocessDepositMigrationButton = ({
  depositMigrationId,
  disabled,
  dispatchPostReprocessDepositMigration,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickConfirm = () => {
    setShowModal(false);
    dispatchPostReprocessDepositMigration({ depositMigrationId });
  };

  return (
    <>
      <Button
        color="warning"
        disabled={disabled}
        onClick={() => setShowModal(true)}
        className="mr-2"
      >
        Reprocesar
      </Button>
      <ConfirmationModal
        show={showModal}
        title="Reprocesar carga"
        body={REPROCESS_CONFIRMATION_MESSAGE}
        onClickConfirm={onClickConfirm}
        onClickCancel={() => setShowModal(false)}
      />
    </>
  );
};

ReprocessDepositMigrationButton.propTypes = {
  depositMigrationId: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  dispatchPostReprocessDepositMigration: PropTypes.func.isRequired,
};

ReprocessDepositMigrationButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchPostReprocessDepositMigration: postReprocessDepositMigration,
};

export { ReprocessDepositMigrationButton };
export default connect(
  null,
  mapDispatchToProps,
)(ReprocessDepositMigrationButton);
